var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    stroke: "#c5221f",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-x-icon lucide-circle-x",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 37,
    style: {
      stroke: "rgb(197, 34, 31)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 30 L30 58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 L58 58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.ad18a6e9f165aec26061248380f3d2ba.svg";
export { ForwardRef as ReactComponent };